/* eslint-disable no-unused-vars */
import { authActions } from "Features/auth";
import { selectUser, userActions } from "Features/user";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export const CheckUserPage = () => {
	const dispatch = useDispatch();
	useEffect(() => {
		dispatch(authActions.check());
	}, []);
	return <></>;
};
